/* Ubezpieczenie paczki jako UPSELL w szufladzie koszyka.

   Uklad i zachowanie jak w TORSIVO (snippets/ts-cart-protect.liquid): suwak jest
   DOMYSLNIE WLACZONY, klient moze go wylaczyc. Wybor zapisujemy w localStorage
   pod 'mb-insurance' - raz wylaczone nie wraca przy kolejnym dodaniu do koszyka.

   UWAGA PRAWNA (decyzja wlasciciela, zapisana swiadomie): domyslnie zaznaczona
   platna opcja jest w UE zabroniona - dyrektywa 2011/83/UE art. 22, w Czechach
   pilnuje tego COI. Zmiana na domyslnie wylaczone to jedna linia: patrz
   funkcja `preferencja()`.

   SYNCHRONIZACJA (poprawka po zgloszeniu: usuniecie kawy zostawialo w koszyku
   samo ubezpieczenie, a ponowne dodanie je dublowalo).
   Poprzednia wersja czekala na zdarzenia Horizona ('cart:update' itp.). Motyw
   nie zawsze je wystawia na `document`, wiec po usunieciu pozycji nasz kod
   w ogole sie nie budzil. Teraz podpinamy sie pod `fetch` i po KAZDYM zapytaniu
   do /cart/* przeliczamy stan. To dziala niezaleznie od tego, jak motyw nazywa
   swoje zdarzenia i czy w ogole je wysyla. */
(function () {
  'use strict';

  // Uchwyt produktu z ubezpieczeniem. Nadpisywalny, gdyby sklep mial inny.
  var HANDLE = window.MB_INSURANCE_HANDLE || 'ubezpieczenie-paczki-oriz';

  // Uchwyty gratisow. Gratisy sa darmowe i same z siebie nie sa powodem, zeby
  // trzymac koszyk przy zyciu - po usunieciu kawy maja wyleciec razem z nia.
  var GRATISY = window.MB_GIFT_HANDLES || ['oriz-ebook-30denni-denik', 'oriz-tajemny-darek'];

  var TEKST = {
    tytul: 'Pojištění zásilky',
    opis: 'Ochrana před poškozením, ztrátou nebo krádeží zásilky',
    aria: 'Přidat pojištění zásilky',
  };

  var KLUCZ = 'mb-insurance';
  var produkt = null;      // { variantId, cena, obrazek }
  var zajety = false;      // trwa przelaczanie suwaka
  var wewnetrzne = false;  // trwa NASZE zapytanie do /cart/* - nie reagujemy na siebie
  var probowanoDodac = false;

  // 'on' = domyslnie zaznaczone. Zmiana na 'off' czyni z ubezpieczenia opcje
  // wybierana swiadomie (zgodna z dyrektywa 2011/83/UE).
  function preferencja() {
    try { return localStorage.getItem(KLUCZ) === 'off' ? 'off' : 'on'; }
    catch (e) { return 'on'; }
  }
  function zapiszPreferencje(v) {
    try { localStorage.setItem(KLUCZ, v); } catch (e) {}
  }

  function korzen() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Sklep chodzi w CZK i formatuje "59,00 Kč".
  function cena(halerze) {
    return (halerze / 100).toFixed(2).replace('.', ',') + ' Kč';
  }

  function pobierzProdukt() {
    if (produkt) return Promise.resolve(produkt);
    return fetch(korzen() + 'products/' + HANDLE + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return null;
        produkt = {
          variantId: p.variants[0].id,
          cena: p.variants[0].price,
          obrazek: p.featured_image || (p.images && p.images[0]) || '',
        };
        return produkt;
      })
      .catch(function () { return null; });
  }

  function stanKoszyka() {
    return fetch(korzen() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function gniazdo() {
    return document.querySelector('.cart-drawer__summary')
        || document.querySelector('#shopify-section-cart-drawer-section .cart-summary')
        || document.querySelector('.cart-summary');
  }

  function zbudujWiersz(dane, wlaczone) {
    var wrap = document.createElement('div');
    wrap.className = 'mb-ins';
    wrap.setAttribute('data-mb-ins', '');
    wrap.innerHTML =
      (dane.obrazek
        ? '<span class="mb-ins__icon mb-ins__icon--img"><img src="' + dane.obrazek +
          '" alt="" width="48" height="48" loading="lazy"></span>'
        : '<span class="mb-ins__icon">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M3 7l9-4 9 4-9 4-9-4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
          '<path d="M3 7v10l9 4V11" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
          '<path d="M21 7v10l-9 4" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
          '</svg></span>') +
      // Cena w kolumnie tresci, pod opisem - tak jest w TORSIVO.
      '<span class="mb-ins__meta"><strong>' + TEKST.tytul + '</strong>' +
      '<span>' + TEKST.opis + '</span>' +
      '<b class="mb-ins__price">' + cena(dane.cena) + '</b></span>' +
      '<button type="button" class="mb-ins__toggle' + (wlaczone ? ' is-on' : '') + '"' +
      ' data-mb-ins-toggle aria-pressed="' + (wlaczone ? 'true' : 'false') +
      '" aria-label="' + TEKST.aria + '"><span></span></button>';
    return wrap;
  }

  /* Jedna droga do zmiany ilosci. update.js przyjmuje mape wariant -> ilosc,
     wiec jest IDEMPOTENTNE: wywolane dwa razy nie zrobi dwoch sztuk. Dlatego
     nigdy nie uzywamy tu add.js - to on potrafil zdublowac linie. */
  function ustawIlosc(variantId, ilosc) {
    var updates = {};
    updates[variantId] = ilosc;
    wewnetrzne = true;
    return fetch(korzen() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sekcje() }),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (window.__mbDrawer && typeof window.__mbDrawer.refresh === 'function' && d && d.sections) {
          window.__mbDrawer.refresh(d.sections);
        }
        return d;
      })
      .then(function (d) { wewnetrzne = false; return d; },
            function (e) { wewnetrzne = false; throw e; });
  }

  function sekcje() {
    return (window.__mbDrawer && window.__mbDrawer.sekcje && window.__mbDrawer.sekcje())
      || 'cart-drawer-section,cart-icon-bubble';
  }

  /* Serce poprawki. Wywolywane po KAZDEJ zmianie koszyka. Pilnuje trzech rzeczy:
       1. nie ma platnych pozycji  -> ubezpieczenie i gratisy won z koszyka
       2. jest wiecej niz 1 szt ubezpieczenia -> zbijamy do 1
       3. preferencja 'on' i brak ubezpieczenia -> dokladamy raz
     i dopiero potem rysuje wiersz z suwakiem. */
  function synchronizuj() {
    var cel = gniazdo();

    return Promise.all([pobierzProdukt(), stanKoszyka()]).then(function (w) {
      var dane = w[0], koszyk = w[1];
      if (!dane || !koszyk) return;

      var linia = null, platne = 0, gratisy = [];
      koszyk.items.forEach(function (i) {
        if (i.variant_id === dane.variantId) { linia = i; return; }
        if (GRATISY.indexOf(i.handle) > -1 || i.price === 0) { gratisy.push(i); return; }
        platne += i.quantity;
      });

      var istniejacy = document.querySelector('[data-mb-ins]');

      // 1. Koszyk bez platnych pozycji: samo ubezpieczenie albo same gratisy nie
      //    maja sensu. To byl zgloszony blad - usuniecie kawy zostawialo je w koszyku.
      if (platne === 0) {
        if (istniejacy) istniejacy.remove();
        var doWyczyszczenia = {};
        if (linia) doWyczyszczenia[dane.variantId] = 0;
        gratisy.forEach(function (g) { doWyczyszczenia[g.variant_id] = 0; });
        if (Object.keys(doWyczyszczenia).length) {
          wewnetrzne = true;
          return fetch(korzen() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: doWyczyszczenia, sections: sekcje() }),
          })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (window.__mbDrawer && typeof window.__mbDrawer.refresh === 'function' && d && d.sections) {
                window.__mbDrawer.refresh(d.sections);
              }
            })
            .then(function () { wewnetrzne = false; }, function () { wewnetrzne = false; });
        }
        return;
      }

      // 2. Bezpiecznik na dublet: ilosc ubezpieczenia zawsze dokladnie 1.
      if (linia && linia.quantity > 1) {
        return ustawIlosc(dane.variantId, 1).then(function () { setTimeout(synchronizuj, 60); });
      }

      // 3. Domyslnie zaznaczone: dokladamy raz na wizyte, gdy klient nie wylaczyl.
      if (!linia && preferencja() === 'on' && !probowanoDodac) {
        probowanoDodac = true;
        return ustawIlosc(dane.variantId, 1)
          .then(function () { setTimeout(synchronizuj, 60); })
          .catch(function () { setTimeout(synchronizuj, 60); });
      }

      if (!cel) return;
      var wlaczone = !!linia;
      if (istniejacy) {
        var btn = istniejacy.querySelector('[data-mb-ins-toggle]');
        btn.classList.toggle('is-on', wlaczone);
        btn.setAttribute('aria-pressed', wlaczone ? 'true' : 'false');
        btn.classList.remove('is-busy');
        if (istniejacy.parentNode !== cel) cel.insertBefore(istniejacy, cel.firstChild);
        return;
      }
      cel.insertBefore(zbudujWiersz(dane, wlaczone), cel.firstChild);
    });
  }

  function przelacz(btn) {
    if (zajety || !produkt) return;
    zajety = true;
    var wlacz = !btn.classList.contains('is-on');
    btn.classList.add('is-busy');
    btn.classList.toggle('is-on', wlacz);
    btn.setAttribute('aria-pressed', wlacz ? 'true' : 'false');
    // Zapis PRZED zapytaniem: gdyby siec padla, wybor klienta i tak zostaje.
    zapiszPreferencje(wlacz ? 'on' : 'off');
    probowanoDodac = !wlacz;   // wylaczenie blokuje automat do konca wizyty

    ustawIlosc(produkt.variantId, wlacz ? 1 : 0)
      .catch(function () {
        // Nie udalo sie - cofamy suwak i preferencje, zeby nie klamaly o koszyku.
        btn.classList.toggle('is-on', !wlacz);
        zapiszPreferencje(wlacz ? 'off' : 'on');
      })
      .then(function () {
        zajety = false;
        setTimeout(synchronizuj, 80);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mb-ins-toggle]');
    if (btn) przelacz(btn);
  });

  /* Podpiecie pod fetch. Kazde zapytanie motywu do /cart/add|change|update|clear
     konczy sie naszym przeliczeniem. Nie zalezymy juz od nazw zdarzen Horizona,
     bo to wlasnie one nie dochodzily po usunieciu pozycji z koszyka. */
  (function podepnijFetch() {
    if (!window.fetch || window.__mbInsHooked) return;
    window.__mbInsHooked = true;
    var oryginal = window.fetch;
    window.fetch = function (zasob, opcje) {
      var url = '';
      try { url = typeof zasob === 'string' ? zasob : (zasob && zasob.url) || ''; } catch (e) {}
      var koszykowe = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      var wynik = oryginal.apply(this, arguments);
      if (koszykowe && !wewnetrzne) {
        wynik.then(function () { setTimeout(synchronizuj, 120); }, function () {});
      }
      return wynik;
    };
  })();

  // Zapas: zdarzenia motywu, gdyby jednak leciały, oraz nasze wlasne.
  ['cart:update', 'cart:lines-update', 'cart:refresh', 'mb:cart:updated']
    .forEach(function (n) {
      document.addEventListener(n, function () { if (!wewnetrzne) setTimeout(synchronizuj, 140); });
    });

  /* Obserwator na wypadek przerysowania szuflady. W poprzedniej wersji wychodzil
     od razu, gdy wiersz juz istnial - przez to po usunieciu pozycji nic nie
     przeliczalo stanu. Teraz tylko dlawimy czestotliwosc. */
  function obserwuj() {
    var cel = document.querySelector('theme-drawer#cart-drawer') || document.querySelector('cart-drawer');
    if (!cel || !window.MutationObserver) return;
    var czeka = false;
    new MutationObserver(function () {
      if (czeka || wewnetrzne) return;
      czeka = true;
      setTimeout(function () { czeka = false; synchronizuj(); }, 200);
    }).observe(cel, { childList: true, subtree: true });
  }

  function start() { synchronizuj(); obserwuj(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function () { setTimeout(start, 60); });
})();
